/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  string, number
} from 'prop-types';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { Price } from '@thd-olt-component-react/price';
import { ProductQuantity } from '@thd-olt-component-react/quantity';
import { SuperSku } from '@thd-olt-component-react/super-sku';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import {
  ProductPod,
  ProductATC,
  ProductRating,
  ProductSponsored,
  ProductImage,
  ProductIdentifier,
  ProductSample,
  ProductBadge,
  ProductCustomOptions,
  PodSpacer,
  ProductPodPlaceholder,
  PodRow,
  PodSection,
  PodTapper
} from '@thd-olt-component-react/product-pod';
import './integrated-brand.scss';

export const IntegratedBrandPod = ({
  itemId,
  storeId,
  parent,
  position,
  url
}) => {

  const { data, loading } = useDataModel('product', { variables: { itemId } });
  if (!data || loading) {
    return (
      <ProductPodPlaceholder podsCount={1} podType="list" />
    );
  }
  return (
    <div className="sui-border-1 sui-border-solid sui-border-primary sui-overflow-hidden">
      <div className="sui-flex sui-w-full sui-h-full">
        <ProductPod
          itemId={itemId}
          hasSSKU
          analyticsData={{
            parent, position
          }}
          padding="sui-p-2 sm:sui-pt-2 sm:sui-px-4 sm:sui-pb-4"
          render={(pod) => (
            <>
              <a
                className="sui-top-0 sui-left-0 sui-absolute sui-size-full sui-z-10"
                href={url}
                aria-label="Link"
              />
              <div className="sui-relative sui-flex sui-flex-col sui-gap-2 sui-h-full">
                <PodSpacer minHeight="32px">
                  <PodRow rowReverse noPadding>
                    <PodTapper fitWidth zIndex>
                      <AddToList itemId={pod.itemId} showIconButton />
                    </PodTapper>
                  </PodRow>
                </PodSpacer>
                <div
                  className="sui-grid lg:sui-grid-cols-2 lg:sui-grid-rows-1 sui-gap-4 sui-flex-1"
                >
                  <div className="sui-row-span-2">
                    <PodSection
                      noPadding
                      columnAlign
                      relative
                      gap="sui-gap-y-2"
                      zIndex
                      aPointer
                      pointerNone
                      buttonPointer
                    >
                      <PodSpacer noPadding>
                        <ProductImage itemId={pod.itemId} />
                      </PodSpacer>
                      <SuperSku
                        itemId={pod.itemId}
                        storeId={storeId}
                        onChange={pod.onChange}
                        onHover={pod.onSSKUHover}
                        disableMediaAndAvailability
                        miniSwatch
                      />
                    </PodSection>
                  </div>
                  <div className="sui-grid sui-gap-2 sui-h-fit">
                    <PodTapper fitWidth zIndex>
                      <PodSpacer minHeight="84px">
                        <ProductHeader
                          itemId={pod.itemId}
                          brand="above"
                          disableShopThisCollection
                          brandTitleMaxLine={3}
                          titleMaxLine={2}
                        />
                      </PodSpacer>
                    </PodTapper>
                    <PodTapper fitWidth zIndex>
                      <ProductRating itemId={pod.itemId} />
                    </PodTapper>
                  </div>
                  <div className="sui-w-full sui-h-full sui-contents lg:sui-row-span-1">
                    <PodSection noPadding columnAlign alignTop gap="sui-gap-4" marginTop="sui-mt-auto">
                      <PodTapper zIndex pointerNone aPointer buttonPointer spanPointer>
                        <PodSpacer minHeight="64px" noPadding>
                          <Price
                            itemId={pod.itemId}
                            type="simple"
                            storeId={storeId}
                            displayEachUom={false}
                          />
                        </PodSpacer>
                      </PodTapper>
                      <PodTapper zIndex pointerNone aPointer buttonPointer>
                        <PodSpacer noPadding>
                          <FulfillmentPodStore itemId={pod.itemId} storeId={pod.storeId} />
                          <FulfillmentPodShipping itemId={pod.itemId} storeId={pod.storeId} />
                        </PodSpacer>
                      </PodTapper>
                      <div className="sui-flex sui-flex-col sm:sui-flex-row sui-gap-y-2 sm:sui-gap-y-0 sui-w-full
                              sm:sui-items-end sui-mt-8"
                      >
                        <PodTapper zIndex>
                          <div className="sm:sui-w-16 sui-w-full">
                            <ProductQuantity
                              itemId={pod.itemId}
                              onChange={pod.onQuantityUpdate}
                              textOnly
                              wideView
                              hideIfATCDisabled
                            />
                          </div>
                        </PodTapper>
                        <div className="sui-grow sui-z-20">
                          <ProductATC
                            itemId={pod.itemId}
                            storeId={storeId}
                            outline
                          />
                        </div>
                      </div>
                    </PodSection>
                  </div>
                </div>
              </div>
            </>
          )}
        />
      </div>
    </div>
  );
};

IntegratedBrandPod.dataModel = extend(
  Favorite,
  ProductPod,
  Price,
  SuperSku,
  ProductATC,
  ProductRating,
  ProductImage,
  ProductSample,
  ProductIdentifier,
  ProductHeader,
  ProductBadge,
  ProductSponsored,
  FulfillmentPodStore,
  FulfillmentPodShipping,
  ProductCustomOptions,
  KeyProductFeatures
);

IntegratedBrandPod.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  parent: string.isRequired,
  position: number.isRequired
};

IntegratedBrandPod.defaultProps = {};

IntegratedBrandPod.displayName = 'IntegratedBrandPod';
